import { plaintextValidator } from '../fields';

export default {
  files: {
    presence: { allowEmpty: false }
  },
  'parent.value': plaintextValidator({ mandatory: true }),
  visibility: {
    presence: { allowEmpty: false }
  }
};
